import { AttributesMixin, define, Model, type } from "@type-r/models";
import { Payment } from "./payment";

export interface PaymentVaultCard extends AttributesMixin<typeof PaymentVaultCard> { }
@define
export class PaymentVaultCard extends Model {

    static idAttribute = "id";

    static attributes = {
        stateId: Number,
        createdOn: type(Date),
        uid: String,
        dataset: type(Payment).dontSave,
        hashKey: String,
        updatedOn: type(Date),
        eTag: String,
        assetTypeId: Number,
        dataSourceId: Number,
        platformCode: String,
        createdBy: String
    };
}